
if (!customElements.get('aquain-capacity')) {
  customElements.define('aquain-capacity', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.hardness = this.querySelector('[data-hardness]');
      this.unit = this.querySelector('[data-unit]');
      this.daily = this.querySelector('[data-daily]');
      this.lastReference = Number(this.unit.value);
      this.addEventListener('input', (event) => {
        if (event.target === this.unit) {
          const previous = Number(this.hardness.value);
          const nextReference = Number(this.unit.value);
          if (previous > 0) this.hardness.value = (previous * nextReference / this.lastReference).toFixed(1);
          this.lastReference = nextReference;
        }
        this.update();
      });
      this.update();
    }
    update() {
      const hardness = Number(this.hardness.value);
      const reference = Number(this.unit.value);
      const daily = Number(this.daily.value);
      const valid = Number.isFinite(hardness) && hardness > 0;
      const dailyValid = this.daily.value === '' || (Number.isFinite(daily) && daily > 0);
      this.hardness.setAttribute('aria-invalid', String(!valid));
      this.daily.setAttribute('aria-invalid', String(!dailyValid));
      const format = new Intl.NumberFormat('de-CH', {maximumFractionDigits:0});
      const summaries = [];
      this.querySelectorAll('[data-capacity]').forEach(row => {
        const capacity = Number(row.dataset.capacity) * reference / hardness;
        const litres = valid ? format.format(Math.floor(capacity)) + ' ' + this.dataset.literLabel : '—';
        const days = valid && dailyValid && daily > 0 ? format.format(Math.floor(capacity / daily)) + ' ' + this.dataset.daysLabel : '—';
        row.querySelector('[data-litres]').textContent = litres;
        row.querySelector('[data-days]').textContent = days;
        summaries.push(row.querySelector('th').textContent.trim() + ': ' + litres);
      });
      this.querySelector('[data-status]').textContent = valid && dailyValid ? summaries.join(' · ') : this.dataset.error;
    }
  });
}
